import dayjs from "dayjs";
import { DateRangePreset } from "../api/types";

export interface IResolvedDateRange {
  fromDate: string;
  toDate: string;
}

export function resolveDateRange(
  preset: DateRangePreset,
  customFromDate?: string | null,
  customToDate?: string | null,
): IResolvedDateRange {
  switch (preset) {
    case "today":
      return {
        fromDate: dayjs().startOf("day").toString(),
        toDate: dayjs().endOf("day").toString(),
      };
    case "thisWeek":
      return {
        fromDate: dayjs().startOf("week").toString(),
        toDate: dayjs().endOf("week").toString(),
      };
    case "thisMonth":
      return {
        fromDate: dayjs().startOf("month").toString(),
        toDate: dayjs().endOf("month").toString(),
      };
    case "custom":
      return {
        fromDate: customFromDate ?? dayjs().startOf("year").toString(),
        toDate: customToDate ?? dayjs().endOf("year").toString(),
      };
    case "thisYear":
    default:
      return {
        fromDate: dayjs().startOf("year").toString(),
        toDate: dayjs().endOf("year").toString(),
      };
  }
}
